<template>
<!-- A general UI to display messages to the viewer/broadcaster -->
<div v-if="messageToViewer.length" class="message-of-the-day">
    <UserProfileImage :src="broadcasterUser.profileImg" />
    <div class="text">{{ messageToViewer }}</div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

import UserProfileImage from '@/components/UserProfileImage'

export default {
    name: 'MessageToViewers',
    data: () => ({
        oauthState: null,
        guanzoUser: {
            profileImg: 'https://static-cdn.jtvnw.net/jtv_user_pictures/bd1d2400-3c33-48b8-8e13-50d866b6ad89-profile_image-300x300.png'
        }
    }),
    computed: {
        ...mapGetters([
            'broadcasterUser',
            'messageToViewer',
        ]),
    },
    components: {
        UserProfileImage,
    },
}
</script>

<style lang="scss" scoped>
$img-size: 30px;
$margin: 5px;
// img should take exactly 2 lines, so the 3rd line
$line-height: ($img-size + $margin * 2) / 2;

.message-of-the-day {
    display: flex;
    align-items: center;
    padding: 8px;
    font-size: 0.8rem;
    border-bottom: 1px solid $border-color;
    .profile-img {
        flex: 0 0 $img-size;
        width: $img-size;
        height: $img-size;
        margin: $margin $margin * 2 $margin 0;
    }
    .text {
        line-height: $line-height;
        word-wrap: break-word;
        overflow: hidden;
    }
}
</style>
